module.exports = __webpack_public_path__ + "img/ppt.a43fbe5e.svg";